import { useState } from 'react'

import type { PublicInvoice } from '@snootsvet/shared/portal'

import { CompactInvoiceCard } from '@/customer/components/billing/invoice-card'
import { Pagination } from '@/customer/components/pagination'
import { resolvePetNames } from '@/customer/lib/pets'

const PAGE_SIZE = 5

/**
 * Paginated list of invoice cards. Shows `PAGE_SIZE` invoices at a
 * time with previous/next controls.
 */
export function InvoiceList({
  invoices,
  petNamesById,
}: {
  invoices: PublicInvoice[]
  petNamesById: Map<string, string>
}) {
  const [page, setPage] = useState(1)
  const totalPages = Math.ceil(invoices.length / PAGE_SIZE)
  const pageInvoices = invoices.slice((page - 1) * PAGE_SIZE, page * PAGE_SIZE)

  return (
    <div className="flex flex-col gap-2">
      {pageInvoices.map((inv) => (
        <CompactInvoiceCard
          key={inv.id}
          invoice={inv}
          petName={resolvePetNames(inv.petIds, petNamesById)}
        />
      ))}

      <Pagination page={page} totalPages={totalPages} onPageChange={setPage} />
    </div>
  )
}
